import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import { validaSoloNumero } from '../../util/varios';

export const CambiodeDatos = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const anioefis = JSON.parse(localStorage.getItem('efiscalanio'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [activo, setActivo] = useState(true);
    const [visibleF, setVisibleF] = useState(false);
    const [visibleC, setVisibleC] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCodigo = useRef();
    const txtFecha = useRef();

    useEffect(() => {
        if (visibleF){
            txtFecha.current.value = moment.utc(props.fecha).format('YYYY-MM-DD');
            txtFecha.current.focus();
        }
        if (visibleC){
            txtCodigo.current.focus();
        }
    }, [visibleF, visibleF]);

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if ((props.llamado === 1 || props.llamado === 4 || props.llamado === 5 || props.llamado === 7) && txtCodigo.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Código!', icono: 'informacion' });
            sigue = false;
            txtCodigo.current.focus();
        } else if ((props.llamado === 1 || props.llamado === 2 || props.llamado === 3 || props.llamado === 6 || props.llamado === 7) && txtFecha.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Fecha', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        } else if ((props.llamado === 1 || props.llamado === 2 || props.llamado === 3 || props.llamado === 6 || props.llamado === 7) && new Date(txtFecha.current.value).getFullYear() !== anioefis) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El año no debe ser diferente al año del Ejercicio Fiscal actual', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        } else if ((props.llamado === 1 || props.llamado === 2 || props.llamado === 3 || props.llamado === 6 || props.llamado === 7) && props.fechad > txtFecha.current.value && props.validarfechad) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta Fecha no Puede ser Anterior a la Fecha del Documento', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        } else if (sigue) {
            var codigo = "0";
            var fecha = "";
            if (props.llamado === 1 || props.llamado === 4 || props.llamado === 5 || props.llamado === 7){
                codigo = txtCodigo.current.value;
            }
            if (props.llamado === 1 || props.llamado === 2 || props.llamado === 3 || props.llamado === 6 || props.llamado === 7){
                fecha = txtFecha.current.value;
            }
            props.onHideConfirmar(codigo, fecha, props.llamado);
            blanquear();
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'fecha') {
            setActivo(false);
        }
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);

        if (event.which === 13 || typeof (event.which) === 'undefined') {


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        if (visibleC){
            txtCodigo.current.value = '';
        }
        if (visibleF){
            txtFecha.current.value = '';
        }
        setActivo(true);
        setVisibleC(false);
        setVisibleF(false);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lx"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                if (props.llamado === 1) {
                    setVisibleC(true);
                    setVisibleF(true);
                } else if (props.llamado === 2){
                    setVisibleC(false);
                    setVisibleF(true);
                   
                    //label.setText(" Introduzca Fecha Según Banco ");
                } else if (props.llamado === 3){
                    setVisibleC(false);
                    setVisibleF(true);
                   
                    //label.setText(" Introduzca Fecha de Reverso ");
                } else if (props.llamado === 4){
                    setVisibleC(true);
                    setVisibleF(false);
                    //txtCodigo.current.focus();
                } else if (props.llamado === 5){
                    setVisibleC(true);
                    setVisibleF(false);
                    //txtCodigo.current.focus();
                } else if (props.llamado === 6){
                    setVisibleC(false);
                    setVisibleF(true);
                    //label.setText(" Introduzca Fecha de Anulación ");
                } else if (props.llamado === 7){
                    setVisibleC(true);
                    setVisibleF(true);
                    //txtCodigo.current.focus();
                    //lblLogin.setText("DOCUMENTO:");
                }
                //txtFecha.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Cambio de Datos'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                                <legend className="float-none m-0 w-auto">Datos</legend>

                                <div className='row m-0 px-0'>


                                    <div className='mb-1 col-sm-12 row m-0'>
                                        {visibleC ?
                                            <div className='col-sm-6 mb-1 px-1' style={{ visibility: visibleC ? 'visible' : 'hidden' }}>
                                                <div className="input-group input-group-sm m-0 w-100">
                                                    <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                                                    <input type="text" onBlur={handleInputNumChange} onKeyUp={handleInputNumChange} className="form-control text-uppercase" name='codigo' disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} ref={txtCodigo} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="codigo" />
                                                </div>
                                            </div>
                                            :
                                            ''
                                        }
                                        {visibleF ?
                                            <div className='col-sm-6 mb-1 px-1'style={{ visibility: visibleF ? 'visible' : 'hidden' }}>
                                                <div className="input-group input-group-sm m-0 w-100">
                                                    <label className="input-group-text" id="inputGroup-sizing-sm">Fecha:</label>
                                                    <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtFecha} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="fecha" />
                                                </div>
                                            </div>
                                            :
                                            ''
                                        }
                                    </div>

                                </div>

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} /* disabled={activo} */ onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}